<a
  [attr.href]="anchor ? anchor : null"
  [attr.routerLink]="routerLink ? routerLink : null"
  class="btn h-[3rem] w-full btn-elevated"
  [class.btn-secondary]="type === 'secondary'"
  [class.btn-hero]="type === 'primary'"
  (click)="callToActionClick.emit()"
  role="button"
>
  <ng-content></ng-content>
</a>
